import * as React from 'react';
export const negativeCircleFilledSvg = React.forwardRef(
  function negativeCircleFilledSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM4.875 7.125a.875.875 0 1 0 0 1.75h6.25a.875.875 0 0 0 0-1.75h-6.25Z',
      }),
    );
  },
);
negativeCircleFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var negativeCircleFilled = {
  category: 'icon',
  colorable: true,
  name: 'negativeCircleFilled',
  svg: negativeCircleFilledSvg,
};
